module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-main"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "breadcrumb-item"
  }, [_vm._v(_vm._s(this.$route.params.namespace))])]), _vm._v(" "), _c('h1', {
    staticClass: "page-title"
  }, [_vm._v(_vm._s(_vm.$t('team.labels.setting')))])]), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body panel-form"
  }, [(_vm.isLoading) ? _c('loading-indicator') : _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('h3', {
    staticClass: "card-title"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('team.labels.rename')) + "\n              ")]), _vm._v(" "), _c('alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAlert),
      expression: "showAlert"
    }],
    attrs: {
      "alertClass": "m-b-25 alert-dismissible",
      "type": ("" + ((_vm.successResponse) ? 'success' : 'danger')),
      "iconClass": ("" + ((_vm.successResponse) ? 'md-check' : 'md-close'))
    }
  }, [(_vm.successResponse) ? _c('span', [_vm._v(_vm._s(_vm.successResponse))]) : (_vm.errorResponse) ? _c('span', [_vm._v(_vm._s(_vm.errorResponse))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-section"
  }, [_c('form-group', {
    attrs: {
      "error": _vm.formErrors.first('name')
    }
  }, [_c('label', {
    attrs: {
      "for": "team"
    }
  }, [_vm._v(_vm._s(_vm.$t('team.displayName.labels')))]), _vm._v(" "), _c('span', {
    staticClass: "guideline-block"
  }, [_vm._v(_vm._s(_vm.$t('team.displayName.textGuide')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.team.name),
      expression: "team.name"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "text",
      "id": "name",
      "placeholder": "Team Display name"
    },
    domProps: {
      "value": _vm._s(_vm.team.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.team.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('form-group', [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('team.url.labels')))]), _vm._v(" "), _c('span', {
    staticClass: "help-block m-t-0"
  }, [_vm._v(_vm._s(_vm.$t('team.url.textGuide')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_vm._v(_vm._s((_vm.baseURL + "/")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.team.namespace),
      expression: "team.namespace"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "text",
      "id": "namespace",
      "placeholder": "Team URL",
      "disabled": "true"
    },
    domProps: {
      "value": _vm._s(_vm.team.namespace)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.team.namespace = $event.target.value
      }
    }
  })])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-success",
    class: {
      'btn-default': _vm.isSubmiting
    },
    attrs: {
      "type": "submit",
      "disabled": _vm.isSubmiting
    }
  }, [(_vm.isSubmiting) ? _c('div', {
    staticClass: "loader vertical-align-middle loader-circle loader-form"
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.$t('team.action.submit')) + "\n              ")])])])])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-27f1b8d7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/teams/TeamSetting.vue
// module id = 519
// module chunks = 1